import { W as WuiCodeSnippet$1, d as defineCustomElement$1 } from './p-BTgD4Fvz.js';

const WuiCodeSnippet = WuiCodeSnippet$1;
const defineCustomElement = defineCustomElement$1;

export { WuiCodeSnippet, defineCustomElement };
